// RollOSS brand system — wordmark + belt + tagline.
// Chosen direction: Hybrid A (Roll**OSS** + 4-stripe belt + "The OS for Jiu-Jitsu" tagline).

export const TAGLINE = "The OS for Jiu-Jitsu";

// Belt-stripe element: green underline with 4 white belt stripes in the middle.
export function BeltStripe({ width = 320 }) {
  return (
    <div className="flex items-center" style={{ gap: 6, width }}>
      <div style={{ flex: 1, height: 3, background: "var(--green)", borderRadius: 2 }} />
      <div style={{ width: 8, height: 13, background: "#fff", borderRadius: 2 }} />
      <div style={{ width: 8, height: 13, background: "#fff", borderRadius: 2 }} />
      <div style={{ width: 8, height: 13, background: "#fff", borderRadius: 2 }} />
      <div style={{ width: 8, height: 13, background: "#fff", borderRadius: 2 }} />
      <div style={{ flex: 1, height: 3, background: "var(--green)", borderRadius: 2 }} />
    </div>
  );
}

// Compact wordmark — for tight horizontal contexts (nav, sidebar header).
export function Wordmark({ size = 18 }) {
  return (
    <span className="font-bold tracking-tight" style={{ fontFamily: "'Geist', sans-serif", fontSize: size, letterSpacing: "-0.02em" }}>
      Roll<span style={{ color: "var(--green)" }}>OSS</span>
    </span>
  );
}

// Full lockup — wordmark + belt + tagline. For footers, login, hero anchors.
export function LogoLockup({ size = 36, beltWidth, tagSize = 11 }) {
  const belt = beltWidth || Math.round(size * 6.5);
  return (
    <div className="inline-flex flex-col items-center" style={{ gap: 12 }}>
      <span className="font-bold tracking-tight" style={{ fontFamily: "'Geist', sans-serif", fontSize: size, letterSpacing: "-0.03em", lineHeight: 1 }}>
        Roll<span style={{ color: "var(--green)" }}>OSS</span>
      </span>
      <BeltStripe width={belt} />
      <span style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: tagSize, letterSpacing: "0.28em",
        textTransform: "uppercase", color: "var(--text-dim)"
      }}>
        {TAGLINE}
      </span>
    </div>
  );
}

// Compact mark for square/tight contexts (favicon, avatar, mobile menu brand chip).
// Derived from the same belt-stripe motif: dark tile, green "OSS" letters, stripe accent.
export function LogoMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="RollOSS">
      <rect width="64" height="64" rx="14" fill="#0a0b0a" />
      <text x="32" y="40" textAnchor="middle"
        fontFamily="'Geist', sans-serif" fontWeight="900" fontSize="26"
        letterSpacing="-1.5" fill="#3ddc7e">
        OSS
      </text>
      {/* 4 micro belt stripes */}
      <rect x="20" y="48" width="3" height="6" rx="1" fill="#ffffff" />
      <rect x="25" y="48" width="3" height="6" rx="1" fill="#ffffff" />
      <rect x="30" y="48" width="3" height="6" rx="1" fill="#ffffff" />
      <rect x="35" y="48" width="3" height="6" rx="1" fill="#ffffff" />
      <rect x="14" y="50" width="4" height="2" rx="1" fill="#3ddc7e" />
      <rect x="46" y="50" width="4" height="2" rx="1" fill="#3ddc7e" />
    </svg>
  );
}
